import { IconButton } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
export const Composer = forwardRef(({ onSend, disabled = false }, ref) => {
    const [value, setValue] = useState('');
    const textareaRef = useRef(null);
    useImperativeHandle(ref, () => ({
        // preventScroll so opening the panel doesn't jump the page.
        focus: () => textareaRef.current?.focus({ preventScroll: true })
    }));
    const send = () => {
        const text = value.trim();
        if (!text || disabled)
            return;
        onSend(text);
        setValue('');
        textareaRef.current?.focus();
    };
    // Enter sends; Shift+Enter inserts a newline.
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            send();
        }
    };
    return (React.createElement("div", { className: "ai-assistant__composer" },
        React.createElement("textarea", { className: "ai-assistant__composer-input", disabled: disabled, onChange: (event) => {
                setValue(event.target.value);
            }, onKeyDown: handleKeyDown, placeholder: "Ask the assistant\u2026", ref: textareaRef, rows: 2, value: value }),
        React.createElement(IconButton, { "aria-label": "Send message", className: "ai-assistant__send", disabled: disabled || !value.trim(), onClick: send },
            React.createElement(SendIcon, null))));
});
Composer.displayName = 'Composer';
